import * as msal from "@azure/msal-browser";
import getUserAndClaims, { UserAndClaims } from "./getUserAndClaims";
const getActiveSessionData = (
  pc: msal.PublicClientApplication,
  loginRequest: msal.SilentRequest
): Promise<UserAndClaims> => {
  const accounts = pc.getAllAccounts();
  return new Promise<UserAndClaims>(async (resolve, reject) => {
    try {
      if (accounts?.length) {
        if (accounts.length > 1) {
          pc.logoutPopup();
        }
        const account: msal.AccountInfo = accounts[0];
        const email = (account?.idTokenClaims as any)?.email;
        if (email) {
          (loginRequest as any).loginHint = email;
        }
        const response: msal.AuthenticationResult = await pc.acquireTokenSilent(
          { ...loginRequest, account }
        );
        const result = getUserAndClaims(pc, response);
        resolve(result);
      } else {
        reject({
          claims: null,
          user: null,
          token: null,
          error: new msal.AuthError("No local accounts found."),
        });
      }
    } catch (err: any) {
      reject({ claims: null, user: null, token: null, error: err });
    }
  });
};
export default getActiveSessionData;
